export const FLAG_GETTING_PRICING_PROFILE_MASSIVE_UPDATES =
  'FLAG_GETTING_PRICING_PROFILE_MASSIVE_UPDATES';
export const GET_PRICING_PROFILE_MASSIVE_UPDATES =
  'GET_PRICING_PROFILE_MASSIVE_UPDATES';
export const CLEAR_PRICING_PROFILE_MASSIVE_UPDATES =
  'CLEAR_PRICING_PROFILE_MASSIVE_UPDATES';
export const GET_PRICING_PROFILE_MASSIVE_UPDATE =
  'GET_PRICING_PROFILE_MASSIVE_UPDATE';
export const CLEAR_PRICING_PROFILE_MASSIVE_UPDATE =
  'CLEAR_PRICING_PROFILE_MASSIVE_UPDATE';
export const FLAG_PRICING_PROFILE_MASSIVE_UPDATE_ACTIVITY =
  'FLAG_PRICING_PROFILE_MASSIVE_UPDATE_ACTIVITY';
